/************
 Product image popup
 ************/


// open popup event listener
document.querySelectorAll(".openPopup").forEach(function (element) {
    element.addEventListener("click", function () {
        // set popup image
        document.querySelector("#productPopupContentImg").src = this.querySelector("img").src;

        // open dialog
        document.querySelector("#productPopup").showModal();
        document.querySelector("#productPopup").classList.add("active");
        document.querySelector('#productPopupContent').classList.add('active');
        document.querySelector("body").classList.add("noScroll");

    });
});

// close popup event listener
document.querySelector("#productPopup").addEventListener("click", function (event) {
    document.querySelector('#productPopupContent').classList.remove('active');
    document.querySelector("#productPopup").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");

    // Wait before closing - allows animation to complete
    setTimeout(function () {
        document.querySelector("#productPopup").close();
    }, 400);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#productPopup"));


/************
 Product Swiper
 ************/

// swiper - mobile only
new Swiper('#productInnerContentMobile', {
    // width: 300,
    slidesPerView: "auto",
    spaceBetween: 30,
    loop: true,
});

/**************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
})

// listen for select menu change
document.querySelector("#product select")?.addEventListener("change", function () {
    // enable button
    document.querySelector("#productInnerContentWrapATC").disabled = false;

    updateProduct();
});

// update selling plan price
document.querySelectorAll('.productInnerContentWrapTypeBtn.subscription')?.forEach(function (element) {
    let saveAmount = element.querySelector('input').dataset.savings;
    document.querySelector('#productInnerContentWrapATCPrice').textContent = price(product.price - (product.price * (saveAmount / 100)));
});


// gift card properties
let properties = {};

// update active variant
function updateProduct() {

    // update active variant (from radio btns)
    let choice = document.querySelector("#product .productInnerContentWrapRadiosBtnInput:checked");

    // gift card variants
    if (giftCard) {
        choice = document.querySelector("#product .productInnerContentFormRadiosBtnInput:checked");
    }

    // if no variant (from radios), check if there's a select menu
    if (!choice) {
        choice = document.querySelector("#product select option:checked");
    }

    // if no choice found from inputs or select menus, use default variant
    if (choice) {
        activeVariant = product.variants.find(variant => variant.id === parseInt(choice.value));
    } else {
        activeVariant = product.variants[0];
    }


    //update weight if there are radio buttons for selecting weight
    if (document.querySelector("#productInnerContentWrapRadios")) {
        if (document.querySelector(".productInnerContentWrapRadiosBtnInput:checked").dataset.weight !== '0.0 oz') {
            document.querySelector(".productInnerContentTitleWeight").textContent = document.querySelector(".productInnerContentWrapRadiosBtnInput:checked").dataset.weight;
        }
    }

    // update properties (gift card)
    document.querySelectorAll("#productInnerContentForm input")?.forEach(function (element) {
        properties[element.name] = element.value;
    });


    //update source images if there are any and if the radio buttons exist
    let productImages = document.querySelectorAll('.productInnerVisualItemImg');

    // front images
    // if the radio buttons exist and the checked radio has front image data
    if (document.querySelector("#productInnerContentWrapRadios") && document.querySelector(".productInnerContentWrapRadiosBtnInput:checked").dataset.front) {
        // update image
        productImages[0].src = document.querySelector(".productInnerContentWrapRadiosBtnInput:checked").dataset.front;
    } else {
        // revert to original image
        if (!giftCard && product.images[0]) {
            productImages[0].src = product.images[0];
        }
    }

    // back images
    // if the radio buttons exist and the checked radio has back image data
    if (document.querySelector("#productInnerContentWrapRadios") && document.querySelector(".productInnerContentWrapRadiosBtnInput:checked").dataset.back) {
        // update image
        productImages[1].src = document.querySelector(".productInnerContentWrapRadiosBtnInput:checked").dataset.back;
    } else {
        // revert to original image
        if (!giftCard && product.images[1]) {
            productImages[1].src = product.images[1];
        }
    }

    // nutrition images
    // if the radio buttons exist and the checked radio has a nutrition image data
    if (productImages.length > 2) {
        if (document.querySelector("#productInnerContentWrapRadios") && document.querySelector(".productInnerContentWrapRadiosBtnInput:checked").dataset.nutrition) {
            // update image
            productImages[2].src = document.querySelector(".productInnerContentWrapRadiosBtnInput:checked").dataset.nutrition;
        } else {
            // revert to original image
            if (!giftCard) {
                productImages[2].src = product.images[2];
            }
        }
    }


    // check if variant wasn't found
    if (activeVariant === null) {
        document.querySelector(".productBtn").disabled = true;
        document.querySelector(".productBtnTxt").textContent = "Not Available";
        return;
    }

    // check if variant is yet to be selected
    if (activeVariant === undefined) {
        document.querySelector(".productBtn").disabled = true;
        document.querySelector(".productBtnTxt").textContent = "Select Options";
        return;
    }

    // update gift card
    if (giftCard) {

        if (activeVariant.available) {
            document.querySelector("#productInnerContentFormATC").disabled = false;
            document.querySelector("#productInnerContentFormATC").textContent = "Add To Cart: " + price(activeVariant.price);            // update price

        } else {
            document.querySelector("#productInnerContentFormATC").disabled = true;
            document.querySelector("#productInnerContentFormATC").textContent = "Sold Out";
        }

        return;
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector(".productBtn").disabled = false;
        document.querySelector(".productBtnTxt").textContent = "Add To Cart";
        // update price
        document.querySelector(".productBtnPrice").textContent = ": " + price(activeVariant.price);

        // if subscription
        if (document.querySelector('.productInnerContentWrapTypeBtn.subscription input')?.checked) {
            let saveAmount = document.querySelector('.productInnerContentWrapTypeBtn.subscription input:checked').dataset.savings;
            document.querySelector(".productBtnPrice").textContent = ": " + price((activeVariant.price - (activeVariant.price * (saveAmount / 100))) * quantity);
        }
    } else {
        document.querySelector(".productBtn").disabled = true;
        document.querySelector(".productBtnTxt").textContent = "Sold Out";
        document.querySelector(".productBtnPrice").textContent = "";
    }

    // check if compare price > price
    if (activeVariant.compare_at_price > activeVariant.price) {
        document.querySelector(".productBtnCompare").textContent = ` ` + price(activeVariant.compare_at_price);
    } else {
        document.querySelector(".productBtnCompare").textContent = "";
    }
}

updateProduct();

/**************
 Product Quantity
 ***************/
let quantity = 1;

// minus
document.querySelector("#productInnerContentWrapQtyMinus")?.addEventListener("click", function () {
    // must not be less than 1
    if (quantity === 1) {
        return;
    }

    // decrement by 1
    quantity--;
    document.querySelector("#productInnerContentWrapQtyNum").textContent = quantity;
    updateProduct();
});

// plus
document.querySelector("#productInnerContentWrapQtyPlus")?.addEventListener("click", function () {
    // increment by 1
    quantity++;
    document.querySelector("#productInnerContentWrapQtyNum").textContent = quantity;
    updateProduct();
});

/**************
 Product ATC
 ***************/

document.querySelector(".productBtn").addEventListener("click", async function () {

    // check if gift card name is valid
    if (giftCard && document.querySelector('#recipientName').value === '') {
        alert('Please enter a recipient name');
        return;
    }

    // check if gift card email valid
    if (giftCard && document.querySelector('#recipientEmail').value === '') {
        alert('Please enter a recipient email');
        return;
    }
    let isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (giftCard && !isValidEmail(document.querySelector('#recipientEmail').value)) {
        alert('Please enter a valid email');
        return;
    }


    // add loading animation
    this.classList.add("loading");


    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
            properties: properties || null
        }]
    };

    // check for subscription
    if (document.querySelector('.productInnerContentWrapTypeBtn.subscription input')?.checked) {
        // add to form data
        formData.items[0].selling_plan = parseInt(document.querySelector('.productInnerContentWrapTypeBtn.subscription input:checked').value);
    }

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});

/**************
 Product info  tabs
 ***************/

// listen for change on input
document.querySelectorAll(".productBottomControlsBtnInput").forEach(function (element) {
    element.addEventListener("change", function () {
        // get value
        let value = this.value;

        // hide all tab items except the one with the target value
        document.querySelectorAll(".productBottomBodyWapItem").forEach(function (element) {
            if (element.dataset.target === value) {
                element.classList.add("active");
            } else {
                element.classList.remove("active");
            }
        });
    });
});

